import {mapActions, mapState} from "vuex";

export default {
  methods: {mapActions},
  computed: {
    ...mapState('statistics', ['isLoadingActions', 'actionsData']),
  }
}